export const redirect = (uri: string) => {
  window.location.replace(uri);
}
